import { render, staticRenderFns } from "./TransferCar.vue?vue&type=template&id=62b90232&"
import script from "./TransferCar.vue?vue&type=script&lang=js&"
export * from "./TransferCar.vue?vue&type=script&lang=js&"
import style0 from "./TransferCar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports